/**
 * @description: 账单制作
 * @author: hwx
 */
<template>
	<div class="make-manage-wrap">
		<h1>账单制作</h1>
		<div class="row">
			<!-- 列表 -->
			<div class="col-md-6 make-list">
				<div class="row row-margin">
					<label class="col-md-1 list-label-2">时间:</label>
					<div class="col-md-3 list-date">
						<div ref="time">
							<input type="text" class="form-control laydate-icon" v-model="start_time"> -
							<input type="text" class="form-control laydate-icon" v-model="end_time">
						</div>
					</div>
					<label class="col-md-1 list-label-2">门店:</label>
					<div class="col-md-4 ct-col">
						<select class="form-control" data-placeholder="请选择门店" ref="make_shop"></select>
					</div>
				</div>
				<div class="row row-margin">
					<label class="col-md-1 list-label-4">支付类型:</label>
					<div class="col-md-4">
						<input class="form-control input-readonly" placeholder="请选择支付类型" v-model="make_paytype_txt" ref="make_paytype_txt" @click="openPaytype($event)" readonly>
						<span class="selection-clear" @click="clearInput">×</span>
						<span class="span-arrow" role="presentation"><b></b></span>
					</div>
					<div class="col-md-6">
						账单实收金额大于: <input class="form-control" v-model="make_amount_min"> 元
					</div>
				</div>
				<div class="row row-margin">
					<div class="col-md-6">
						账单实收金额小于: <input class="form-control" v-model="make_amount_max"> 元
					</div>
					<label class="list-label-8">账单实收金额小计:</label>
					<div class="list-total" ref="make_amount_total"></div>
				</div>
				<div class="row">
					<div class="pull-right">
						<button type="button" class="btn btn-flat btn-middle btn-orange" @click="makeOnlyPkg">只保留开房套餐</button>
						<button type="button" class="btn btn-flat btn-middle btn-orange" @click="delMultiMake">批量删除</button>
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="makeQuery">查询</button>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered table-hover" data-pagination="true" ref="make_list"></table>
				</div>
				<!-- 支付类型弹窗 -->
				<div class="paytype-sel-wrap" ref="paytype_sel_wrap">
					<ul class="clearfix">
						<li>
							<input type="checkbox" id="pall" v-model='paytype_all' @click="paytypeSelAll">
							<label for="pall">全选</label>
						</li>
						<li v-for="item in paytype_arr">
							<input type="checkbox" :id="item.id" v-model="paytype_item" :value="item.id">
							<label :for="item.id">{{item.name}}</label>
						</li>
					</ul>
				</div>
			</div>
			<!-- 新增、修改 -->
			<div class="col-md-6 make-edit" v-show="showEdit">
				<div class="page-tit">{{edit_tit}}<br />账单详情</div>
				<div class="row">
					<div class="pull-right">
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="saveMake">保存</button>
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="printMake(edit_bill_no)">打印</button>
					</div>
				</div>
				<div class="row make-edit-base">
					<div class="row">
						<label class="col-md-2">账单号:</label>
						<span class="col-md-5">{{edit_bill_no}}</span>
					</div>
					<div class="row">
						<label class="col-md-2">消费门店:</label>
						<span class="col-md-5">{{edit_shop}}</span>
					</div>
					<div class="row">
						<label class="col-md-2">消费包厢:</label>
						<span class="col-md-5">{{edit_box}}</span>
					</div>
					<div class="row edit-start-time">
						<label class="col-md-2">开房时间:</label>
						<span class="col-md-5">{{edit_start_time}}</span>
					</div>
					<div class="row">
						<label class="col-md-2">结束时间:</label>
						<span class="col-md-5">{{edit_end_time}}</span>
						<div class="col-md-2" ref="make_edit_time">
							<img src="../../assets/images/make_edit.png">
						</div>
					</div>
					<div class="row">
						<label class="col-md-2">消费时长:</label>
						<span class="col-md-5">{{edit_time_len}}</span>
					</div>
				</div>
				<div class="row make-edit-goods">
					<div class="row">
						<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="addGoods">新增商品</button>
					</div>
					<div class="table-responsive">
						<table class="table table-bordered table-hover" data-pagination="true" ref="make_goods_list"></table>
					</div>
					<div class="row goods-amount-total">
						<div class="pull-right">
							<label class="col-md-1 list-label-4">实收金额:</label>
							<span>{{goods_amount_total}}</span>
						</div>
					</div>
				</div>
				<div class="row make-pay-log">
					<h3>付款记录</h3>
					<div class="row">
						<button type="button" class="btn btn-flat btn-middle btn-orange pull-right" @click="addPayLog">新增付款记录</button>
					</div>
					<ul>
						<li class="clearfix" v-for="(item, index) in make_pay_log">
							<div class="col-md-6">
								<div class="col-md-10">
									{{item.create_time}}
								</div>
							</div>
							<div class="col-md-6">
								<div class="col-md-10">
									{{item.pay_platform_name}}：￥{{item.actual_pay}}
								</div>
								<div @click="modifyPayLog(item, index)">
									<img src="../../assets/images/make_edit.png">
								</div>
							</div>
						</li>
					</ul>
				</div>

				<!-- 商品列表弹窗 -->
				<div class="goods-list-alert" ref="goods_list_alert">
					<div class="row">
						<div class="col-md-3 ct-col">
							<select class="form-control" ref="goods_type"></select>
						</div>
						<div class="col-md-6">
							<input type="text" class="form-control" placeholder="请输入商品名称" v-model="goods_name" @keyup.13="queryGoods" />
						</div>
						<div class="col-md-3">
							<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="queryGoods">查询</button>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-bordered table-hover" data-pagination="true" ref="goods_list"></table>
					</div>
				</div>
				<!-- 新增、修改付款记录弹窗 -->
				<div class="pay-log-edit" ref="pay_log_edit">
					<div class="row">
						<label class="col-md-3">支付时间：</label>
						<div class="col-md-9">
							<div ref="pay_log_date">
								<input type="text" class="form-control laydate-icon" v-model="pay_log_time">
							</div>
						</div>
					</div>
					<div class="row">
						<label class="col-md-3">支付类型：</label>
						<div class="col-md-9 ct-col">
							<select class="form-control" data-placeholder="请选择支付类型" ref="pay_log_type"></select>
						</div>
					</div>
					<div class="row">
						<label class="col-md-3">支付金额：</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="请输入支付金额" v-model="pay_log_amount">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		// name: 'order_manage',
		data() {
			return {
				showEdit: false,
				start_time: '',
				end_time: '',
				make_paytype_txt: '',
				paytype_arr: [],
				paytype_all: false,
				c_paytype_all: false,
				paytype_item: [],
				make_amount_min: '',
				make_amount_max: '',
				make_list_total: '',

				edit_tit: '',
				edit_bill_no: '',
				edit_shop_id: '',
				edit_shop: '',
				edit_box: '',
				edit_start_time: '',
				edit_end_time: '',
				edit_time_len: '',
				make_goods_arr: [],
				goods_amount_total: 0,
				make_pay_log: [],
				goods_name: '',
				pay_log_time: '',
				pay_log_amount: '',
			}
		},
		watch: {
			make_paytype_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.make_paytype_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.make_paytype_txt).parent().find('.selection-clear').hide();
					}
				},
				deep:true
			},
			paytype_item: {
				handler: function(val, oldVal) {
					if(this.paytype_item.length >= this.paytype_arr.length) {
						this.paytype_all = true;
						this.c_paytype_all = true;
					} else {
						this.paytype_all = false;
						this.c_paytype_all = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			let _this = this;
			// 日期
			let myDate = new Date();
			_this.IntstartTime = new Date(myDate.getTime() - 1 * 24 * 3600 * 1000);
			_this.IntendTime = new Date(myDate.getTime() - 1 * 24 * 3600 * 1000);
			let timStar = new Date(this.IntstartTime),
				year = timStar.getFullYear(),
				month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
				day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate();
			let timEnd = new Date(this.IntendTime),
				yearend = timEnd.getFullYear(),
				monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
				dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate();
			_this.start_time = year + '-' + month + '-' + day;
			_this.end_time = yearend + '-' + monthend + '-' + dayend;
			_this.initDate();
			_this.getShopList();
		},
		methods: {
			// 初始化日期插件
			initDate: function() {
				let _this = this;

				$(_this.$refs.time).daterangepicker({
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.start_time = start.format('YYYY-MM-DD');
					_this.end_time = end.format('YYYY-MM-DD');
				});

				$(_this.$refs.make_edit_time).daterangepicker({
					parentEl: '.edit-start-time',
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray'
				}, function(start, end, label) {
					_this.edit_start_time = start.format('YYYY-MM-DD HH:mm');
					_this.edit_end_time = end.format('YYYY-MM-DD HH:mm');
				});

				$(_this.$refs.pay_log_date).daterangepicker({
					singleDatePicker: true, // 设置成单日历
					// parentEl: '.make-pay-log',
					// drops: 'up',
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function(start, end, label) {
					_this.pay_log_time = start.format('YYYY-MM-DD HH:mm');
				});
			},
			// 获取门店
			getShopList: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();
							$(_this.$refs.make_shop).select2({
								data: arr,
								allowClear: true,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								// 获取支付类型
								_this.make_paytype_txt = '';
								_this.paytype_item = [];
								_this.getPaytype(e.params.data.id, '1');
							});
							// 获取支付类型
							_this.getPaytype($(_this.$refs.make_shop).val(), '1');

							_this.initTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取支付类型
			getPaytype: function(shop_id, type) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Order/getAllPayPlatform",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							let value = data.response.data;
							if(type == '1') {
								for(var key in value) {
									arr.push({id: key, name: value[key]});
								}
								_this.paytype_arr = arr;
							} else if(type == '2') {
								for(var key in value) {
									arr.push({id: key, text: value[key]});
								}
								$(_this.$refs.pay_log_type).html('');
								$(_this.$refs.pay_log_type).select2({
									data: arr,
									language: "zh-CN",
									width: '100%'
								});
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 打开支付类型
			openPaytype: function() {
				let _this = this;

				let c_paytype_item = _this.paytype_item;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['支付类型', true],
					area: ['660px', ''],
					content: $(_this.$refs.paytype_sel_wrap),
					offset: '100px',
					cancel: function() {
						// 右上角关闭
						if(_this.make_paytype_txt != "") {
							_this.paytype_item = c_paytype_item;
							return;
						}
						_this.paytype_item = [];
					}
				}, function() {
					let texts = [];
					_this.paytype_arr.forEach(function(item) {
						_this.paytype_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.make_paytype_txt = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.make_paytype_txt != "") {
						_this.paytype_item = c_paytype_item;
						return;
					}
					_this.paytype_item = [];
				});
			},
			// 全选
			paytypeSelAll: function() {
				let _this = this;

				_this.paytype_all = _this.c_paytype_all;
				if(!_this.paytype_all) { // 实现全选
					_this.paytype_item = [];
					_this.paytype_arr.forEach(function(item) {
						_this.paytype_item.push(item.id);
					});
				} else { // 实现反选
					_this.paytype_item = [];
				}
			},
			// 清空多选
			clearInput: function() {
				this.make_paytype_txt = '';
				this.paytype_item = [];
			},
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.make_list).bootstrapTable('destroy');
				$(_this.$refs.make_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getMakeList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "index",
						title: "行号",
						width: "8%",
						valign: "middle",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "room_area_name",
						title: "包厢<br />区域",
						width: "10%",
						valign: "middle"
					}, {
						field: "room_name",
						title: "消费<br />包厢",
						width: "10%",
						valign: "middle"
					}, {
						field: "bill_no",
						title: "账单号",
						width: "15%",
						valign: "middle"
					}, {
						field: "amount",
						title: "实收金额",
						width: "15%",
						valign: "middle"
					}, {
						field: "start_time",
						title: "开房时间",
						width: "15%",
						valign: "middle"
					}, {
						title: "操作",
						width: "15%",
						valign: "middle",
						events: {
							'click .modify': function(e, value, row, index) {
								_this.getMakeDet(row.bill_no);
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delMake(row.bill_no);
								});
							},
							'click .print': function(e, value, row, index) {
								_this.printMake(row.bill_no);
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue modify">修改</span><span class="text-blue del">删除</span><span class="text-blue print">打印</span>'
						}
					}, {
						checkbox: true,
						title: "全选",
						valign: "middle"
					}],
				});
			},
			getMakeList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.start_time,
							"end_time": _this.end_time,
							"shop_id": $(_this.$refs.make_shop).val(),
							"pay_platform": _this.paytype_item,
							"amount_min": _this.make_amount_min,
							"amount_max": _this.make_amount_max
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getBillList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.make_list_total = data.response.result.count;
								$(_this.$refs.make_amount_total).text( data.response.result.total_amount);
							}
							params.success({
								total: _this.make_list_total,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			makeQuery: function() {
				this.initTable();
			},
			// 只保留开房套餐
			makeOnlyPkg: function() {
				let _this = this;
				if(_this.start_time != _this.end_time) {
					layer.msg('只能处理一天的数据，开始时间要等于结束时间');
					return false;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"start_time": _this.start_time,
							"end_time": _this.end_time,
							"shop_id": $(_this.$refs.make_shop).val(),
							"pay_platform": _this.paytype_item,
							"amount_min": _this.make_amount_min,
							"amount_max": _this.make_amount_max
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/setOnlyRoomPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.make_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 详情
			getMakeDet: function(bill_no) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": bill_no
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getBillDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let det = data.response.result;
							_this.edit_tit = det.shop_name;
							_this.edit_bill_no = det.bill_no;
							_this.edit_shop_id = det.shop_id;
							_this.edit_shop = det.shop_name;
							_this.edit_box = det.room_name;
							_this.edit_start_time = det.start_time;
							_this.edit_end_time = det.end_time;
							_this.edit_time_len = det.total_time;
							_this.make_goods_arr = det.goods_info;
							_this.initGoodsTable();
							// 实收金额
							_this.getAmountTotal();
							_this.make_pay_log = det.pay_info;
							_this.showEdit = true;

							_this.$nextTick(function() {
								_this.initGoodsType();
								_this.initAllGoods(_this.edit_shop_id);
								_this.getPaytype(_this.edit_shop_id, '2');
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 计算实收金额
			getAmountTotal: function() {
				let _this = this;
				_this.goods_amount_total = 0;
				$.each(_this.make_goods_arr, function(k, v) {
					_this.goods_amount_total += parseFloat(v.amount);
				});
			},
			// 商品表格
			initGoodsTable: function() {
				let _this = this;
				$(_this.$refs.make_goods_list).bootstrapTable('destroy');
				$(_this.$refs.make_goods_list).bootstrapTable({
					pagination: false,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						align: "left",
						width: "30%",
						valign: "middle"
					}, {
						field: "quantity",
						title: "数量",
						width: "15%",
						valign: "middle",
						events: {
							'blur .goods-quantity': function(e, value, row, index) {
								_this.make_goods_arr[index].quantity = $.trim($(this).val());
								_this.make_goods_arr[index].amount = $.trim($(this).val()) * _this.make_goods_arr[index].price;
								_this.initGoodsTable();
								_this.getAmountTotal();
							}
						},
						formatter: function(value, row) {
							// return row.quantity + row.goods_unit_name;
							return '<input type="text" class="goods-quantity" value="'+ value +'" /> ' + row.goods_unit_name;
						}
					}, {
						field: "price",
						title: "单价",
						width: "15%",
						valign: "middle",
						events: {
							'blur .goods-price': function(e, value, row, index) {
								_this.make_goods_arr[index].price = $.trim($(this).val());
								_this.make_goods_arr[index].amount = $.trim($(this).val()) * _this.make_goods_arr[index].quantity;
								_this.initGoodsTable();
								_this.getAmountTotal();
							}
						},
						formatter: function(value, row) {
							return '<input type="text" class="goods-price" value="'+ value +'" />';
						}
					}, {
						field: "amount",
						title: "金额",
						width: "14%",
						valign: "middle"
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: {
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									layer.closeAll();
									_this.make_goods_arr.splice(index, 1);
									_this.initGoodsTable();
									_this.getAmountTotal();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue del">删除</span>';
						}
					}, {
						field: 'state1',
						width: '5%',
						align: 'left',
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.detail.length > 0) {
								return "<a href='javascript:' class=\"detail-icon\" ><i class=\"glyphicon glyphicon-plus icon-plus\"></i></a>";
							} else {
								return '';
							}
						}
					}],
					data: _this.make_goods_arr,
					icons: {
						paginationSwitchDown: 'glyphicon-collapse-down icon-chevron-down',
						paginationSwitchUp: 'glyphicon-collapse-up icon-chevron-up',
						refresh: 'glyphicon-refresh icon-refresh',
						toggle: 'glyphicon-list-alt icon-list-alt',
						columns: 'glyphicon-th icon-th',
						detailOpen: 'glyphicon-plus icon-plus',
						detailClose: 'glyphicon-minus icon-minus'
					},
					// 注册加载子表的事件
					onExpandRow: function(index, row, $detail) {
						_this.initSubGoods(index, row, $detail);
					}
				});
				$(".detail-icon").trigger("click");
			},
			// 子表
			initSubGoods: function(index, row, $detail) {
				let str = '';
				if(row.detail.length > 0) {
					$.each(row.detail, function(k, v) {
						str += '<li class="clearfix" style="line-height: 30px;"><div style="float: left; width: 33%; text-align: left;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+ v.goods_name +'</div><div style="float: left; width: 18%">'+ v.quantity + v.goods_unit_name +'</div><div style="float: left; width: 18%">'+ v.price +'</div><div style="float: left; width: 13%">'+ v.amount +'</div></li>';
					});
					$detail.html('<ul style="padding-left: 3%;">'+ str +'</ul>');
				} else {
					$detail.html('<div style="float: left; width: 20%">没有找到匹配的记录</div>');
				}
			},
			// 初始化商品类型
			initGoodsType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{
								id: "0",
								text: "全部"
							}, {
								id: "111",
								text: "开房套餐"
							}, {
								id: "222",
								text: "商品套餐"
							}]
							$.each(data.response.result.data, function(k, v) {
								arr.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.goods_type).html('');
							$(_this.$refs.goods_type).select2({
								data: arr,
								allowClear: true,
								width: '100%'
							}).on("select2:select", function(e) {
								console.log('------------');
								if($(_this.$refs.goods_type).val() == '111') {
									_this.initRoomPackage(_this.edit_shop_id);
									return;
								} else if($(_this.$refs.goods_type).val() == '222') {
									_this.initGoodsPackage(_this.edit_shop_id);
									return;
								}
								_this.initAllGoods(_this.edit_shop_id);
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 所有商品
			initAllGoods: function(shop_id) {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getAllGoodsList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			getAllGoodsList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": $(_this.$refs.goods_type).val(),
							"goods_name": _this.goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 开房套餐列表
			initRoomPackage: function(shop_id) {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getRoomPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '开房套餐'
						}
					}, {
						field: "package_name",
						title: "名称",
						formatter: function(value, row, index) {
							return row.package_name + '(' + row.room_type_name + ')';
						}
					}, {
						field: "box_unit_name",
						title: "单位",
						formatter: function(value, row, index) {
							return '份'
						}
					}],
					clickToSelect: true
				});
			},
			// 获取开房套餐列表
			getRoomPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"package_name": _this.goods_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "RoomPackage/getPackagePriceList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化商品套餐列表
			initGoodsPackage: function(shop_id) {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "name",
						title: "名称"
					}, {
						field: "package_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品套餐列表
			getGoodsPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"name": _this.goods_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询商品
			queryGoods: function() {
				let _this = this;

				if($(_this.$refs.goods_type).val() == '111') {
					_this.initRoomPackage(_this.edit_shop_id);
				} else if($(_this.$refs.goods_type).val() == '222') {
					_this.initGoodsPackage(_this.edit_shop_id);
				} else {
					_this.initAllGoods(_this.edit_shop_id);
				}
			},
			// 新增商品
			addGoods: function() {
				let _this = this;

				_this.goods_name = '';
				$(_this.$refs.goods_list).bootstrapTable('refreshOptions', {pageNumber: '1'});
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['添加商品', true],
					area: ['700px', '500px'],
					content: $(_this.$refs.goods_list_alert),
					offset: '100px'
				}, function() {
					$.map($(_this.$refs.goods_list).bootstrapTable('getSelections'), function(row) {
						for(let i = 0; i < _this.make_goods_arr.length; i++) {
							if(_this.make_goods_arr[i].goods_id == row.id) {
								layer.msg("商品已存在");
								return;
							}
						}
						if($(_this.$refs.goods_type).val() == '111') {
							_this.make_goods_arr.push({ goods_name: row.package_name, quantity: '1', goods_unit_name: '份', price: row.actual_price, amount: row.actual_price, detail: row.detail });
						} else if($(_this.$refs.goods_type).val() == '222') {
							_this.make_goods_arr.push({ goods_name: row.name, quantity: '1', goods_unit_name: row.package_unit_name, price: row.actual_price, amount: row.actual_price, detail: row.detail });
						} else {
							_this.make_goods_arr.push({ goods_name: row.goods_name, quantity: '1', goods_unit_name: row.goods_unit_name, price: row.discount_price, amount: row.discount_price, detail: [] });
						}
						layer.msg("成功添加商品");
					});
					_this.initGoodsTable();
					_this.getAmountTotal();

				});
			},
			// 新增付款记录
			addPayLog: function() {
				this.pay_log_time = '';
				$(this.$refs.pay_log_type).val('').trigger('change');
				this.pay_log_amount = '';
				this.editPayLog('新增付款记录', '1');
			},
			// 修改付款记录
			modifyPayLog: function(item, index) {
				this.pay_log_time = item.create_time;
				$(this.$refs.pay_log_type).val(item.pay_platform).trigger('change');
				this.pay_log_amount = item.actual_pay;
				this.editPayLog('修改付款记录', '2', index);
			},
			editPayLog: function(name, type, index) {
				let _this = this;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: [name, true],
					area: ['660px', ''],
					content: $(_this.$refs.pay_log_edit),
					offset: '100px'
				}, function() {
					if(type == '1') {
						_this.make_pay_log.push({
							create_time: _this.pay_log_time,
							pay_platform: $(_this.$refs.pay_log_type).val(),
							pay_platform_name: $(_this.$refs.pay_log_type).find("option:selected").text(),
							actual_pay: _this.pay_log_amount
						});
						layer.closeAll();
					} else if(type == '2') {
						Vue.set(_this.make_pay_log, index, {
							create_time: _this.pay_log_time,
							pay_platform: $(_this.$refs.pay_log_type).val(),
							pay_platform_name: $(_this.$refs.pay_log_type).find("option:selected").text(),
							actual_pay: _this.pay_log_amount
						});
						layer.closeAll();
					}
				});
			},
			// 修改套账
			saveMake: function() {
				let _this = this;

				let pay_total = 0;
				$.each(_this.make_pay_log, function(k, v) {
					pay_total += parseFloat(v.actual_pay);
				});
				if(pay_total != _this.goods_amount_total) {
					layer.msg('支付金额需要等于实收金额');
					return false;
				}

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": _this.edit_bill_no,
							"start_time": _this.edit_start_time,
							"end_time": _this.edit_end_time,
							"goods_info": _this.make_goods_arr,
							"pay_info": _this.make_pay_log
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/editBill",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.make_list).bootstrapTable('refresh');
							_this.showEdit = false;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除套账
			delMake: function(bill_no) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": bill_no
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/delBill",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.make_list).bootstrapTable('refresh');
							_this.make_list_total--;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 批量删除
			delMultiMake: function() {
				let _this = this;

				layer.confirm('是否确认批量删除选中的列表项，确认删除后将不再恢复。', {
					btn: ['确定', '取消']
				}, function() {
					let bill_no = [];
					$.map($(_this.$refs.make_list).bootstrapTable('getSelections'), function(row) {
						bill_no.push(row.bill_no);
					});
					console.log(bill_no);
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"bill_no": bill_no
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "FalsifyBill/batchDelBill",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
                    	data: datas2,
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.msg(data.response.error_msg);
								$(_this.$refs.make_list).bootstrapTable('refresh');
								_this.make_list_total -= bill_no.length;
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
			// 打印套账
			printMake: function(bill_no) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": bill_no
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/printBill",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			}

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.make-manage-wrap {
		.make-list {
			.col-md-6 {
				padding: 0;
				color: #5e5e5e;
				font-size: 14px;
				input {
					display: inline-block;
					width: 63px;
					margin: 0 10px;
				}
			}
			button {
				margin: 0 0 0 30px;
			}
			table {
				table-layout: fixed;
				word-wrap: break-word;
			}
		}
		.paytype-sel-wrap {
			display: none;
			padding: 20px;
			li {
				float: left;
				width: 20%;
				input {
					float: left;
					margin: 9px 7px 0 0;
				}
				label {
					float: left;
					width: 80%;
					margin: 7.5px 0 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.make-edit {
			button {
				margin: 0 0 0 30px;
			}
			.make-edit-base {
				margin: 20px 0 10px;
				label {
					padding: 0;
					line-height: 32px;
					color: #5e5e5e;
					font-size: 14px;
					text-align: right;
					font-weight: normal;
				}
				span {
					line-height: 32px;
					color: #5e5e5e;
					font-size: 14px;
				}
				img {
					display: block;
					margin: 10px 0;
					cursor: pointer;
				}
				.edit-start-time {
					.daterangepicker {
						width: 600px;
						left: -50px !important;
						top: 350px !important;
					}
					.daterangepicker.opensright:before {
						left: 65%;
					}
					.daterangepicker.opensright:after {
						left: 65%;
					}
				}
			}
			.make-edit-goods {
				.goods-quantity {
					width: 40px;
					height: 30px;
					padding: 0 8px;
					border: 1px solid #d6d6d6;
				}
				.goods-price {
					width: 60px;
					height: 30px;
					padding: 0 8px;
					border: 1px solid #d6d6d6;
				}
				.goods-amount-total {
					margin: 10px 0 50px;
					span {
						line-height: 32px;
						color: #009af0;
						font-size: 14px;
					}
				}
			}
			.goods-list-alert {
				display: none;
				padding: 20px 30px;
				div {
					padding-left: 0;
				}
			}
			.make-pay-log {
				padding: 20px 0 0;
				border-top: 1px solid #e4e4e4;
				h3 {
					margin: 0;
					font-size: 18px;
				}
				>div {
					margin: 20px 0 30px;
				}
				li {
					margin: 0 0 20px;
				}
				img {
					display: block;
					cursor: pointer;
				}
				.daterangepicker {
					width: 600px;
					left: -50px !important;
					top: 350px !important;
				}
				.daterangepicker.opensright:before {
					left: 65%;
				}
				.daterangepicker.opensright:after {
					left: 65%;
				}
			}
			.pay-log-edit {
				display: none;
				width: 70%;
				margin: 20px auto;
				label {
					padding: 0;
					line-height: 32px;
					color: #5e5e5e;
					font-size: 14px;
					text-align: right;
					font-weight: normal;
				}
				.row {
					margin: 0 0 20px;
				}
			}
		}
	}
</style>